import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { SafeImg, HostTips } from "@/components/ImageGallery";

export function EventImagePicker({ value, onChange, entities }) {
  const choices = entities.flatMap((e) => (e.images || []).map((img) => ({ ...img, from: e.name })));
  return (
    <div className="space-y-2" data-testid="event-image-picker">
      <div className="flex items-center justify-between"><Label>Event image (optional)</Label><HostTips /></div>
      <div className="flex items-center gap-2">
        {value && <SafeImg src={value} className="h-12 w-12 shrink-0 rounded" testid="event-image-preview" />}
        <Input value={value} onChange={(e) => onChange(e.target.value)} placeholder="Paste an image link" data-testid="event-image-input" />
        {value && <button type="button" className="text-xs text-[#A8A090] hover:text-red-400" onClick={() => onChange("")} data-testid="event-image-clear">Clear</button>}
      </div>
      {choices.length > 0 && (
        <div>
          <div className="mb-1 text-xs text-[#A8A090]">Or pick from the entries involved:</div>
          <div className="flex flex-wrap gap-1.5">
            {choices.map((c, i) => (
              <button type="button" key={`${c.url}-${i}`} title={`${c.from}${c.caption ? ` · ${c.caption}` : ""}`} onClick={() => onChange(c.url)} data-testid={`event-image-choice-${i}`}
                className={`overflow-hidden rounded border ${value === c.url ? "border-[#D97706] ring-1 ring-[#D97706]" : "border-[#2D3442] hover:border-[#D97706]/60"}`}>
                <SafeImg src={c.url} className="h-12 w-12" />
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
